import * as React from 'react';
import { Link } from 'react-router-dom';
import { useAbility } from '~/lib/ability';
import { ResourceLoader, useResource } from '~/lib/loader';
import { ClientsAbility } from '~/modules/Clients/ability';
import { fetchSellerSources } from '~/modules/Clients/api';
import { Alert } from '~/components/Alert';
import { Breadcrumb, Breadcrumbs } from '~/components/Breadcrumps';
import { Title } from '~/components/Title';
import { usersLinks } from '~/modules/Users';
import style from './index.module.scss';

export const TurniloAdvancedDataView = () => {
    const pageTitle = 'Advanced Reporting';
    const ability = useAbility(ClientsAbility);
    const sellerId = ability.sellerId();

    const header = (
        <div className="page-header-sticky">
            <div className="page-header-breadcrumbs">
                <Breadcrumbs />
            </div>
            <Title className="page-header-title">{pageTitle}</Title>
        </div>
    );

    if (!sellerId) {
        const userProfileLink = usersLinks.user(ability.user.id);
        return (
            <Breadcrumb breadcrumb={{ title: pageTitle }}>
                <div className={style.advancedData}>
                    {header}
                    <Alert
                        className={style.alert}
                        alertText={
                            <>
                                <div>
                                    Advanced reporting is not available because this user is not linked to any seller.
                                </div>
                                <div>
                                    Please assign a seller in this{' '}
                                    <Link to={userProfileLink}>user settings</Link>.
                                </div>
                            </>
                        }
                        type="info"
                    />
                </div>
            </Breadcrumb>
        );
    }

    const fetchSources = useResource(() => fetchSellerSources({sellerId}));

    return (
        <Breadcrumb breadcrumb={{ title: pageTitle }}>
            <div className={style.advancedData}>
                {header}
                <ResourceLoader result={fetchSources} message="Loading...">
                    {({resource: sources, isPending}) => {
                        const [firstSource] = sources || [];
                        const integrationSourceId = firstSource?.integrationSourceId;
                        return (
                            !isPending &&
                            integrationSourceId && (
                                <iframe src={(STAGING ? `https://bi-stage.bidmachine.io/` : `https://bi.bidmachine.io/`) + `turnilo?id=${integrationSourceId}`} />
                            )
                        );
                    }}
                </ResourceLoader>
            </div>
        </Breadcrumb>
    );
};
